// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Panel-module__panel-CtSA1 {
  padding: 24px;
  background-color: var(--background-primary);
  border-width: 1px;
  border-color: var(--border-primary);
  border-radius: var(--mantine-radius-md);
}

[data-mantine-color-scheme='light']:root .nightbot-Panel-module__panel-CtSA1 {
    box-shadow: var(--mantine-shadow-sm);
    border-color: var(--border-secondary);
  }
`, "",{"version":3,"sources":["webpack://./src/components/Panel.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;AACzC;;AAGE;IACE,oCAAoC;IACpC,qCAAqC;EACvC","sourcesContent":[".panel {\n  padding: 24px;\n  background-color: var(--background-primary);\n  border-width: 1px;\n  border-color: var(--border-primary);\n  border-radius: var(--mantine-radius-md);\n}\n\n@mixin light-root {\n  .panel {\n    box-shadow: var(--mantine-shadow-sm);\n    border-color: var(--border-secondary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `nightbot-Panel-module__panel-CtSA1`
};
export default ___CSS_LOADER_EXPORT___;
